import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformCustomCoversMutation } from "../graphql/mutations";
import type {
  UpdatePlatformCustomCoversMutationType,
  UpdatePlatformCustomCoversMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePlatformCustomCoversMutation = (
  options?: MutationHookOptions<
    UpdatePlatformCustomCoversMutationType,
    UpdatePlatformCustomCoversMutationVariablesType
  >
) => {
  return useMutation<
    UpdatePlatformCustomCoversMutationType,
    UpdatePlatformCustomCoversMutationVariablesType
  >(UpdatePlatformCustomCoversMutation, options);
};
